const studentV10LevelMap: Record<number, number> = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  10: 10,
  11: 11,
  12: 15,
  13: 18,
  14: 19,
  15: 20,
  16: 23,
  17: 14,
  18: 12,
  19: 22,
  20: 24,
  21: 25,
  22: 26,
  23: 27,
  24: 28,
  25: 30,
  26: 29,
  27: 31,
  28: 32,
  29: 33,
  30: 38,
  31: 39,
  32: 41,
  33: 42,
  34: 45,
  35: 26,
  36: 27,
  37: 36,
  38: 36,
};

export default function getStudentV10Level(level: number): number {
  if (level in studentV10LevelMap) {
    return studentV10LevelMap[level];
  }

  console.warn(
    `Level ${level} not found in studentV10LevelMap, returning original level`,
  );
  return level;
}
